import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
    },
    backgroundImage: {
      maxWidth: '100%',
      maxHeight: 300,
      objectFit: 'contain',
      borderRadius: theme.shape.borderRadius,
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(2),
    },
    sectionTitle: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      fontWeight: 500,
    },
    mechanicsText: {
      whiteSpace: 'pre-wrap',
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
    },
  })
);
